module.exports = __webpack_public_path__ + "img/wallet.57403aae.png";